import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Urls } from '@core/config/urls';
import { OldLegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class DocumentService extends OldLegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/int/storage/documents';
	}

	private _dom: DomSanitizer = inject(DomSanitizer);

	public getImageUrl(imageId: string): Observable<any> {
		const requestOptions = {
			params: {
				id: imageId,
			},
			responseType: 'blob',
		};

		return this._restClientService.get(`${this.apiUrl}/download`, requestOptions).pipe(
			map((result) => {
				const url = URL.createObjectURL(result);
				return this._dom.bypassSecurityTrustUrl(url);
			})
		);
	}

	public findById(id: string): Observable<any> {
		return this._restClientService.get(`${this.apiUrl}/${id}`);
	}

	public getFile(id): Observable<any> {
		const requestOptions = {
			params: {
				id,
			},
			responseType: 'blob',
		};

		return this._restClientService.get(`${this.apiUrl}/download`, requestOptions);
	}
}
